import { useSelector } from 'react-redux';
import { LOGIN_SYSTEM_TYPES } from 'helpers/variables';
import { OPERATORS, DVR_RECORDINGS_OPERATORS } from 'helpers/operators';

function useOperators() {
	const operator = process.env.REACT_APP_OPERATOR;
	const operatorSystem = process.env.REACT_APP_SYSTEM;
	const { pureott } = LOGIN_SYSTEM_TYPES;
	const { RETAIL } = OPERATORS;

	const { authenticate, isLogged } = useSelector(({ auth }) => auth);
	const source = authenticate?.source;
	const isOperator = !!operator && operator !== RETAIL;
	const isRetailUser = source === pureott && operator === RETAIL;
	const isDvrRecordingsOperator = DVR_RECORDINGS_OPERATORS.includes(source);
	const isRetailOrGuest = isRetailUser || !isLogged;

	return {
		isLogged,
		isRetailUser: isRetailUser,
		isRetailOrGuest,
		isDvrRecordingsOperator,
		source,
		operator,
		operatorSystem,
		isOperator
	};
}

export default useOperators;
